<script setup>
import { ref, computed, onMounted } from 'vue'

const props = defineProps({
  reach: {}
})
const socials = computed(() => props.reach.socials)
const currentIndex = ref(0)
const currentSocial = computed(() => socials.value[currentIndex.value])

onMounted(() => {
  setInterval(() => {
    currentIndex.value = (currentIndex.value + 1) % socials.value?.length
  }, 5000)
})
</script>
<template>
  <div class="social-box" v-if="reach?.socials">
    <transition name="icon-spin" mode="out-in" appear>
      <div
        :key="currentIndex"
        v-html="currentSocial.img"
        class="icon-wrapper"
      ></div>
    </transition>
  </div>
</template>
<style lang="scss" scoped>
.social-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $color_orange-50;
  border-radius: 1000px;
  padding: 24%;
}

.icon-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Настройки анимации */
.icon-spin-enter-active {
  /* Пружинистый эффект через cubic-bezier */
  transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.icon-spin-leave-active {
  transition: all 1s cubic-bezier(1, 0, 1, 1);
}

.icon-spin-enter-from {
  opacity: 0;
  transform: rotate(-180deg) scale(0);
}

.icon-spin-leave-to {
  opacity: 0;
  transform: rotate(180deg) scale(0);
}

/* Чтобы SVG внутри не ломали размеры */
:deep(svg) {
  display: block;
  width: 100%;
  height: auto;
}
</style>